<div class="mt-xs">
  <div @fadeInAnimation>
    <p class="text-info mb-xlg" *ngIf="!recordSelected">Selecciona la ficha del paciente para modificar los datos.</p>
    <div class="records-patient" *ngIf="!this.recordSelected">
      <ng-container *ngFor="let record of records; index as i">
        <div *ngIf="!record.hide" class="record-patient" [ngClass]="['shepherd-file-' + i]" (click)="onSelectRecord(record)" [nzTooltipTitle]="record.name" nzTooltipPlacement="top" nz-tooltip>
          <div class="record-patient-logo">
            <img loading="lazy" [src]="'./assets/images/icons/' + record.icon" alt="">
          </div>
          <div class="tw-w-full">
            <p class="text-info mb-xxs truncate">{{ record.name }}</p>
            <!-- <p class="text-info-bold-xs">Última modificación</p> -->
            <p class="text-info-bold-xs">{{ record.lastUpdated | date : 'MMM d, y, h:mm:ss a' }}</p>
          </div>
        </div>
      </ng-container>
    </div>
    <div *ngIf="recordSelected">
      <div class="d-flex align-items-center mb-xlg">
        <i class="back-option mr-md shepherd-consultation-file-btn-back" (click)="onBackRecords()" nz-icon nzType="arrow-left" nzTheme="outline"></i>
        <div class="option-mini p-xs">
          <div class="option-mini-logo">
            <img loading="lazy" [src]="recordSelected.icon" alt="">
          </div>
          <div class="option-mini-text d-flex flex-column ml-xs">
            <p class="text-info mb-xxs">{{ recordSelected.name }}</p>
            <p class="text-info-bold-xs">Modificado {{ recordSelected.lastUpdated | date : 'MMM d, y, h:mm:ss a' }}</p>
          </div>
        </div>
      </div>

      <div *ngIf="recordSelected.uid === recordTypeEnum.HABITS" class="mb-xs" @fadeInAnimation>
        <app-record-history-habits class="record-history-habits" (otherHabitsChange)="onChangeLastUpdateRecord($event, recordSelected.uid)"></app-record-history-habits> <!--[patient]="patient" - Se estaba pasando al componente, pero el componente no tiene ese input-->
      </div>

      <div *ngIf="recordSelected.uid === recordTypeEnum.PHYSICAL_ACTIVITY" class="mb-xs" @fadeInAnimation>
        <app-record-history-physical-activity (recordPhysicalActivityChange)="onChangeLastUpdateRecord($event, recordSelected.uid)"></app-record-history-physical-activity>
      </div>

      <div class="mb-xs" *ngIf="recordSelected.uid === recordTypeEnum.PERSONAL_MEDIC" @fadeInAnimation>
        <app-record-history-personal-medical (recordMedicalPersonalChange)="onChangeLastUpdateRecord($event, recordSelected.uid)"></app-record-history-personal-medical>
      </div>

      <div class="mb-xs" *ngIf="recordSelected.uid === recordTypeEnum.FAMILIAL_MEDICAL" @fadeInAnimation>
        <app-record-history-familial-medical (recordMedicalHerdedChange)="onChangeLastUpdateRecord($event, recordSelected.uid)"></app-record-history-familial-medical>
      </div>

      <div class="mb-xs" *ngIf="recordSelected.uid === recordTypeEnum.NUTRITIONAL" @fadeInAnimation>
        <app-record-history-nutritional (recordNutritionalChange)="onChangeLastUpdateRecord($event, recordSelected.uid)"></app-record-history-nutritional>
      </div>

      <div class="mb-xs" *ngIf="recordSelected.uid === recordTypeEnum.NUTRITIONAL_PHYSICAL_EXAMINATION" @fadeInAnimation>
        <app-record-history-nutritional-physical-examination (recordNutritionalPhysicalExaminationChange)="onChangeLastUpdateRecord($event, recordSelected.uid)"></app-record-history-nutritional-physical-examination>
      </div>

      <div class="mb-xs" *ngIf="recordSelected.uid === recordTypeEnum.SLEEP" @fadeInAnimation>
        <app-record-history-sleep (sleepChange)="onChangeLastUpdateRecord($event, recordSelected.uid)"></app-record-history-sleep>
      </div>

      <div class="mb-xs" *ngIf="recordSelected.uid === recordTypeEnum.ENVIRONMENT_AFFECTIVITY" @fadeInAnimation>
        <app-record-history-environment-affectivity (recordEnvironmentAffectivityChange)="onChangeLastUpdateRecord($event, recordSelected.uid)"></app-record-history-environment-affectivity>
      </div>

      <div class="mb-xs" *ngIf="recordSelected.uid === recordTypeEnum.ATTITUDE" @fadeInAnimation>
        <app-record-history-attitude (recordHistoryAttitudeChange)="onChangeLastUpdateRecord($event, recordSelected.uid)"> </app-record-history-attitude>
      </div>

      <div class="mb-xs" *ngIf="recordSelected.uid === recordTypeEnum.BIOCHEMISTS" @fadeInAnimation>
        <app-record-history-biochemists (recordHistoryBiochemistsChange)="onChangeLastUpdateRecord($event, recordSelected.uid)"></app-record-history-biochemists>
      </div>

      <div class="mb-xs" *ngIf="recordSelected.uid === recordTypeEnum.MY_EXPERIENCE" @fadeInAnimation>
        <app-record-history-my-experience></app-record-history-my-experience>
      </div>

      <div class="mb-xs" *ngIf="recordSelected.uid === recordTypeEnum.MINI_SPHERE" @fadeInAnimation>
        <app-record-mini-sphere></app-record-mini-sphere>
      </div>

    </div>
  </div>
</div>
